import React from "react";
import globalStyle from "../../styles/globalStyle";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: "none" | "sm" | "md" | "lg" | "xl";
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  className = "",
  hover = false,
  padding = "md",
  onClick,
  ...props
}) => {
  const paddingClasses = {
    none: "",
    sm: "p-3",
    md: "p-4 md:p-6",
    lg: "p-6 md:p-8",
    xl: "p-8 md:p-10",
  }[padding];

  const hoverClass = hover ? globalStyle.cardHover : "";
  const clickableClass = onClick ? "cursor-pointer" : "";

  return (
    <div
      className={`${globalStyle.card} ${paddingClasses} ${hoverClass} ${clickableClass} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
